package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LayersW500Rounded: ImageVector
    get() {
        if (_layersW500Rounded != null) {
            return _layersW500Rounded!!
        }
        _layersW500Rounded = Builder(name = "LayersW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(153.11f, 609.3f)
                quadToRelative(-17.91f, -13.67f, -17.65f, -35.8f)
                quadToRelative(0.26f, -22.13f, 18.38f, -35.85f)
                quadToRelative(12.46f, -9.15f, 27.5f, -9.27f)
                quadToRelative(15.03f, -0.12f, 27.46f, 9.32f)
                lineToRelative(270.96f, 209.95f)
                lineTo(751.2f, 537.7f)
                quadToRelative(12.43f, -9.2f, 27.34f, -9.32f)
                quadToRelative(14.92f, -0.12f, 27.38f, 9.03f)
                quadToRelative(18.12f, 13.72f, 18.5f, 35.97f)
                quadToRelative(0.38f, 22.25f, -17.53f, 35.92f)
                lineTo(535.46f, 820.26f)
                quadToRelative(-25.11f, 19.15f, -55.82f, 19.27f)
                quadToRelative(-30.71f, 0.12f, -55.57f, -19.27f)
                lineTo(153.11f, 609.3f)
                close()
                moveTo(424.07f, 604.39f)
                lineTo(198.85f, 428.98f)
                quadToRelative(-35.31f, -27.27f, -35.31f, -71.57f)
                reflectiveQuadToRelative(35.31f, -71.65f)
                lineToRelative(225.22f, -175.41f)
                quadToRelative(25.1f, -19.15f, 55.69f, -19.15f)
                quadToRelative(30.59f, 0.0f, 55.7f, 19.15f)
                lineToRelative(225.21f, 175.41f)
                quadToRelative(35.31f, 27.26f, 35.31f, 71.57f)
                quadToRelative(0.0f, 44.3f, -35.31f, 71.65f)
                lineTo(535.46f, 604.39f)
                quadToRelative(-25.11f, 19.15f, -55.7f, 19.15f)
                quadToRelative(-30.59f, 0.0f, -55.69f, -19.15f)
                close()
                moveTo(479.76f, 531.78f)
                lineTo(704.98f, 357.37f)
                lineTo(479.76f, 183.2f)
                lineTo(254.54f, 357.37f)
                lineToRelative(225.22f, 174.41f)
                close()
                moveTo(479.76f, 357.37f)
                close()
            }
        }
        .build()
        return _layersW500Rounded!!
    }

private var _layersW500Rounded: ImageVector? = null
